import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

export const miPipOption4: TaskDefinition = {
  taskName: onboardingTasks.ProofOfMIPipOption4,
  config: {
    staffDisplayName: 'Provide proof of MI PIP medical limit eligibility',
    appcuesModalId: '72c3bd49-ad5a-4721-9482-d1b88967e460',
    reviewTeam: reviewTeams.processing,
    daysAllowed: 15,
    enabled: true,
    eventName: 'Provided Proof of MI PIP Option 4',
    account: {
      toastMessage: 'Your proof of Qualified Health Coverage documents have been submitted for review.',
      content: ({ affectedPolicies, daysAllowed, data }) => {
        const primaryDriver = data.primaryDriver || '';
        const excludedResidents = data.excludedResidents?.map((r: { name: string }) => r.name).join(', ') || '';
        return {
          title: 'Provide proof of MI PIP medical limit eligibility',
          incompleteSubtitle:
            'Confirm your eligibility for your selected Personal Injury Protection (PIP) medical limit: "$250K with some excluded residents" by submitting proof of eligibility documents.',
          completedSubtitle: `You've successfully submitted your proof of eligibility for the current Personal Injury Protection (PIP) medical limit on ${affectedPolicies}.`,
          actionLabel: 'Upload proof',
          modalTitle: 'Upload your proof of Qualified Health Coverage',
          contentSections: [
            {
              title: 'What documents are accepted?',
              body: 'To maintain a PIP medical limit of $250K with some excluded residents, you will need to provide:'
            },
            {
              title: null,
              body: [
                `Proof of Qualified Health Coverage (QHC) for ${primaryDriver}.`,
                ...(excludedResidents && excludedResidents.trim().length > 0
                  ? [
                      `Proof of QHC for all other household residents, if applicable, who opted to waive PIP coverage: ${excludedResidents}`
                    ]
                  : [])
              ],
              isList: true
            },
            {
              title: 'When do I need to submit these documents?',
              body: `You have ${daysAllowed} days from your policy effective date to turn in the documents listed above. Without these documents, we'll return the policy's limit to the unlimited default, which will impact the price.`
            }
          ]
        };
      }
    }
  }
};
